import { useTranslation } from 'react-i18next';

const badgeTones: Record<string, string> = {
  New: 'border-sky-200 bg-sky-50 text-sky-800',
  Confirmed: 'border-primary-200 bg-primary-50 text-primary-800',
  AwaitingPayment: 'border-accent-200 bg-accent-50 text-accent-800',
  Paid: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  Shipped: 'border-violet-200 bg-violet-50 text-violet-800',
  ReadyForPickup: 'border-indigo-200 bg-indigo-50 text-indigo-800',
  PickedUp: 'border-violet-200 bg-violet-50 text-violet-800',
  Closed: 'border-background-300 bg-background-100 text-foreground-700',
  WarrantyCase: 'border-rose-200 bg-rose-50 text-rose-700',
  Active: 'border-sky-200 bg-sky-50 text-sky-800',
  Converted: 'border-primary-200 bg-primary-50 text-primary-800',
  Expired: 'border-background-300 bg-background-100 text-foreground-600',
  Declined: 'border-rose-200 bg-rose-50 text-rose-700',
  UnderReview: 'border-accent-200 bg-accent-50 text-accent-800',
  Published: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  Discontinued: 'border-background-300 bg-background-100 text-foreground-600',
  Open: 'border-rose-200 bg-rose-50 text-rose-700',
  ReplacementAgreed: 'border-accent-200 bg-accent-50 text-accent-800',
  Invited: 'border-indigo-200 bg-indigo-50 text-indigo-800',
};

const dotTones: Record<string, string> = {
  New: 'bg-sky-500',
  Confirmed: 'bg-primary-500',
  AwaitingPayment: 'bg-accent-500',
  Paid: 'bg-emerald-500',
  Shipped: 'bg-violet-500',
  ReadyForPickup: 'bg-indigo-500',
  PickedUp: 'bg-violet-500',
  Closed: 'bg-foreground-400',
  WarrantyCase: 'bg-rose-500',
  Active: 'bg-sky-500',
  Converted: 'bg-primary-500',
  Expired: 'bg-foreground-400',
  Declined: 'bg-rose-500',
  UnderReview: 'bg-accent-500',
  Published: 'bg-emerald-500',
  Discontinued: 'bg-foreground-400',
  Open: 'bg-rose-500',
  ReplacementAgreed: 'bg-accent-500',
  Invited: 'bg-indigo-500',
};

interface Props {
  status: string;
  label?: string;
  className?: string;
  dot?: boolean;
}

export default function PortalStatus({ status, label, className = '', dot = true }: Props) {
  const { t } = useTranslation();
  const tone = badgeTones[status] || badgeTones.Closed;
  const dotTone = dotTones[status] || dotTones.Closed;
  const text = label || t(`portal.status.${status}`);

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium leading-5 ${tone} ${className}`}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dotTone}`} />}
      {text}
    </span>
  );
}